// notifications.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  private apiUrl = `${environment.apiUrl}/api/notificar-vencimientos`; 

  constructor(private http: HttpClient) {}

  enviarNotificaciones(): Observable<any> {
    // Enviamos el tipo seleccionado al backend
    return this.http.get(this.apiUrl,{});
  }
}
